import { parseISO } from 'date-fns';
import differenceInYears from 'date-fns/differenceInYears';

export const getBirthDateWithAge = (formatDate: (arg: string) => string, birthDate?: string) => {
  return birthDate
    ? `${formatDate(birthDate)} (${differenceInYears(new Date(), parseISO(birthDate))} yrs old)`
    : '';
};
